import { useQuery } from '@tanstack/react-query';
import { ConsentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useConsentsControllerFindAllQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['consentsControllerFindAll', accessControlScope, args],
        queryFn: async () => {
            const api = new ConsentsApi(accessControlConfig);
            return api.consentsControllerFindAll(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useConsentsControllerFindAllQuery.js.map